module.exports = __webpack_public_path__ + "img/index-security-bottom2.ea40171a.svg";